export class PilotKpiMetrics {
  public static DutyRestHours = {
    id: 'DutyRestHours',
    kpis: { shift1: { granularity: 'Shift', windowSize: 1 } },
  };

  public static Hnvgo = {
    id: 'Hnvgo',
    kpis: { month3: { granularity: 'Month', windowSize: 3 } },
  };

  public static FaaFlightTime = {
    id: 'FaaFlightTime',
    kpis: {
      hour24: { granularity: 'Hour', windowSize: 24 },
      quarter1: { granularity: 'Quarter', windowSize: 1 },
      quarter2: { granularity: 'Quarter', windowSize: 2 },
      year1: { granularity: 'Year', windowSize: 1 },
    },
  };

  public static DutyTime = {
    id: 'DutyTime',
    kpis: { shift1: { granularity: 'Shift', windowSize: 1 } },
  };

  public static NightLandings = {
    id: 'NightLandings',
    kpis: { day90: { granularity: 'Day', windowSize: 90 } },
  };

  public static TotalLandings = {
    id: 'TotalLandings',
    kpis: { day90: { granularity: 'Day', windowSize: 90 } },
  };

  public id: string;
  public kpis: { granularity: string; windowSize: number }[];

  public static create(id: string, kpis: { granularity: string; windowSize: number }[]) {
    return {
      id,
      kpis,
    } as PilotKpiMetrics;
  }
}
